/** @file A document IK constraint as compiled indices: its target bone and its chain. */
import type { IkConstraintDoc } from '@pose2d/format/types';
import type { SceneMaps } from '../../panels/viewport/scene/sceneMaps';

/** Data indices of an IK constraint's bones. */
export interface IkRef { target: number; chain: number[] }

/** null when the rig has not compiled the constraint's bones yet. */
export function ikRef(maps: SceneMaps, c: IkConstraintDoc): IkRef | null {
  const target = maps.boneIndex.get(c.target);
  const chain = c.bones.map((id) => maps.boneIndex.get(id) ?? -1);
  return target === undefined || chain.includes(-1) ? null : { target, chain };
}
